"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var HeaderColumn_1 = require("./HeaderColumn");
var SelectAllColumn_1 = require("./SelectAllColumn");
var Header = function (props) {
    var toggleSelect = props.toggleSelect, items = props.items, selected = props.selected;
    var columnProps = {
        orderByOptions: props.orderByOptions,
        filterOptions: props.filterOptions,
        setOrderBy: props.setOrderBy,
        updateUrl: props.updateUrl,
        queryParams: props.queryParams,
        pathname: props.pathname,
        setColumnFilter: props.setColumnFilter
    };
    return (React.createElement("div", { className: 'header row', style: props.style },
        props.currentBriefcase ? (React.createElement(SelectAllColumn_1.default, { items: items, selected: selected, toggleSelect: toggleSelect })) : (React.createElement("div", { className: "row__column narrow" })),
        React.createElement(HeaderColumn_1.default, __assign({}, columnProps, { identifier: "id" })),
        React.createElement(HeaderColumn_1.default, __assign({}, columnProps, { identifier: "name" })),
        React.createElement(HeaderColumn_1.default, __assign({}, columnProps, { identifier: "description" })),
        props.currentBriefcase && (React.createElement(HeaderColumn_1.default, __assign({}, columnProps, { identifier: "status" }))),
        React.createElement(HeaderColumn_1.default, __assign({}, columnProps, { identifier: "publishedAt" })),
        props.currentBriefcase && (React.createElement(HeaderColumn_1.default, __assign({}, columnProps, { identifier: "updatedAt" }))),
        React.createElement("div", { className: "row__column narrow" })));
};
exports.default = Header;
